import { simpleSet } from '@r/reducers/utils';

const setCalculationModeUnits = simpleSet as
  redux.reducers.calculationMode.settings.information.units;

export const units = setCalculationModeUnits(
  'SET_CALCULATION_MODE_UNITS',
  'inch'
);
